import { render, staticRenderFns } from "./WidddiFooter.vue?vue&type=template&id=ac194fde"
import script from "./WidddiFooter.vue?vue&type=script&lang=js"
export * from "./WidddiFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports